import { Browser } from "@capacitor/browser";
import { useHistory } from "react-router-dom";
import { StorySlide } from "@core/types";
import { useCallback } from "react";
import { useStoriesProviderData } from "../providers/storiesProvider/useStoriesProvider";

export const useStoryButton = (buttonSlot: StorySlide["button"]) => {
  const history = useHistory();
  const { setIsModalOpened, isModalOpened } = useStoriesProviderData();

  const handleStoryButtonClick = useCallback(() => {
    console.log("buttonSlot", buttonSlot);
    if (!buttonSlot) return;

    if (isModalOpened) setIsModalOpened();

    if (buttonSlot.role === "_blank") {
      Browser.open({ url: buttonSlot.link });
    } else {
      history.push(buttonSlot.link);
    }
  }, [buttonSlot, history, setIsModalOpened, isModalOpened]);

  return { handleStoryButtonClick };
};
